var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CanceledLockoutOverlay.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-8c9e3ade!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CanceledLockoutOverlay.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/buybox/CanceledLockoutOverlay.vue
// module id = 664
// module chunks = 2